import { ReactElement } from 'react';
import { Avatar, AvatarSize } from '@nx-frontend/shared/ui/avatar';

interface UserPreviewProps {
  name: string;
  text?: string;
  avatarSize?: AvatarSize;
  avatarUrl?: string;
  avatarBgClass?: string;
  icon?: ReactElement;
}

export const UserPreview: React.FC<UserPreviewProps> = ({ name, avatarUrl, avatarBgClass, icon, text, avatarSize }) => {
  return (
    <div className="flex max-w-full min-w-0">
      <div>
        <Avatar name={name} avatarUrl={avatarUrl} icon={icon} bgClass={avatarBgClass} size={avatarSize} />
      </div>
      <div className="px-2 flex flex-col justify-center overflow-hidden">
        <div className="overflow-hidden text-ellipsis whitespace-nowrap">{name}</div>
        {text && (
          <div className="overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-neutral-500 text-[10px]">
            {text}
          </div>
        )}
      </div>
    </div>
  );
};
